import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const ArrowLeftBig = ({
  width,
  height,
  style,
  className,
  fillClassName,
  fillColor,
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fillColor!}
      fillRule="nonzero"
      className={fillClassName}
      d="M17.0014 2.98469C16.5114 2.49469 15.7214 2.49469 15.2314 2.98469L6.92141 11.2947C6.53141 11.6847 6.53141 12.3147 6.92141 12.7047L15.2314 21.0147C15.7214 21.5047 16.5114 21.5047 17.0014 21.0147C17.4914 20.5247 17.4914 19.7347 17.0014 19.2447L9.76141 11.9947L17.0114 4.74469C17.4914 4.26469 17.4914 3.46469 17.0014 2.98469Z"
    />
  </svg>
);

ArrowLeftBig.defaultProps = {
  width: "24",
  height: "24",
  fillColor: "#63696F",
};

export default ArrowLeftBig;
